// extracted by mini-css-extract-plugin
export default {"backgroundHeader":"G79f599"};